<!-- Navbar (Header) Starts -->
<nav class="header-navbar navbar navbar-expand-lg navbar-light bg-faded">
    <div class="container-fluid">
        <div class="navbar-header">
            <button type="button" class="navbar-toggle d-lg-none float-left" data-toggle="collapse">
              <span class="sr-only">Toggle navigation</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <span class="d-lg-none navbar-right navbar-collapse-toggle">
                <a class="open-navbar-container" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" aria-controls="navbarSupportedContent">
                    <i class="ft-more-vertical"></i>
                </a>
            </span>
            <strong style="color: #3f587e;">{{user.fullName}} / <span style="color: orangered">{{roleName}}</span></strong>
            <br/><strong style="color: #3f587e;"class="mr-2">{{user.vpoName}}</strong>
            <span (click)="openNewTaskDialog()" title="Сообщить о проблеме" class="cursor-pointer"> <i class="ft-info text-danger"></i></span>
        </div>
        <div class="navbar-container">
            <div class="collapse navbar-collapse" id="navbarSupportedContent" [ngbCollapse]="isCollapsed">
                <ng-container *ngIf="user.isAdmin || user.roleCode === 'admin'">
                  <ul class="navbar-nav system" style="margin-right: 20px">
                    <li class="nav-item mr-2">
                      <a routerLink="/manage" class="nav-link"><i class="fa fa-home"></i> Главная</a>
                    </li>
                    <li class="nav-item mr-2  d-none d-lg-block">
                      <a routerLink="/manage/system/structures" class="nav-link">Структуры</a>
                    </li>
                    <li class="nav-item mr-2  d-none d-lg-block">
                      <a routerLink="/manage/system/templates" class="nav-link">Шаблоны</a>
                    </li>
                    <li class="nav-item mr-2  d-none d-lg-block">
                      <a routerLink="/manage/sections/complaints" class="nav-link">Обращения</a>
                    </li>
                  </ul>
                </ng-container>
                <ul class="navbar-nav">
                    <li class="nav-item mr-2  d-none d-lg-block">
                        <a href="javascript:;" class="nav-link" id="navbar-fullscreen" appToggleFullscreen (click)="ToggleClass()">
                            <i class="{{toggleClass}} font-medium-3 blue-grey darken-4"></i>
                            <p class="d-none">Развернуть</p>
                        </a>
                    </li>
                    <li class="nav-item" ngbDropdown [placement]="placement">
                        <a class="nav-link position-relative" id="dropdownBasic3" ngbDropdownToggle>
                            <i class="ft-user font-medium-3 blue-grey darken-4" style="color: #1CBCD8 !important;"></i>
                            <p class="d-none">User Settings</p>
                        </a>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic3" class="text-left" style="top: 48px; left: -112px;">
                            <a class="dropdown-item py-1" routerLink="/manage/personal/profile">
                                <i class="ft-edit mr-2"></i>
                                <span>Профиль</span>
                            </a>
                            <a class="dropdown-item py-1" href="javascript:;">
                                <i class="ft-settings mr-2"></i>
                                <span>Настройки</span>
                            </a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" routerLink="/manage/login">
                                <i class="ft-power mr-2"></i>
                                <span>Выйти</span>
                            </a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</nav>

<!-- Navbar (Header) Ends -->
